import React from 'react';
import { Typography } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { STEP_CONFIG } from '../../constants';
import { getStepIndex } from '../../lib';
import { useDealBuilderStepNavigation } from '../../hooks';
import { StepFooterNav } from '../components/StepFooterNav';

export const DealBuilderStepPlaceholder = () => {
  const { viewStep } = useDealBuilderStepNavigation();

  const stepConfig = STEP_CONFIG[getStepIndex(viewStep)];

  return (
    <CardContainer>
      <Typography variant="h6">{stepConfig.label}</Typography>
      <Typography variant="body2" color="text.secondary">
        This step's fields are not implemented yet.
      </Typography>

      <StepFooterNav />
    </CardContainer>
  );
};
